export default "__VITE_ASSET__DBRkx__4__"